import React from 'react'
import './Research.css'
import Tags from '../Components/Tags'
import gif_texel from '../gif/texel.gif'
import img_texel from '../img/research/texel.png'
import gif_chandelier from '../gif/chandelier.gif'
import img_chandelier from '../img/research/chandelier.png'
import gif_flaticulation from '../gif/flaticulation.gif'
import img_flaticulation from '../img/research/flaticulation.png'
import gif_polagons from '../gif/polagon.gif'
import img_polagons from '../img/research/polagons.png'
import gif_structcode from '../gif/structcode.gif'
import img_structcode from '../img/research/structcode.png'
import gif_portalink from '../gif/portalink.gif'
import img_portalink from '../img/research/portalink.png'
import pdf_flaticulation from '../pdf/Flaticulation.pdf'
import pdf_texel from '../pdf/TexelBlocks.pdf'
import pdf_chandelier from '../pdf/Chandelier.pdf'
import design from "../pdf/design_portfolio_vivian.pdf"
import pdf from "../pdf/CV2026.pdf"

export default class Research extends React.Component {
    render(){
        return (
            <div id="research">

                <Publication_temp imgSrc={img_portalink} gifSrc={gif_portalink}
                                    title="PortalInk: 2.5D Visual Storytelling with SVG Parallax and Waypoint Transitions"
                                    author={<p>Tongyu Zhou, Joshua Kong Yang, <b>Vivian Hsinyueh Chan</b>, Ji Won Chung, Jeff Huang</p>}
                                    status={<p>Proceedings at UIST 2024</p>}
                                    links={
                                        <div>
                                            <Pub_link name='ACM' link='https://dl.acm.org/doi/10.1145/3654777.3676376' />
                                            <Pub_link name='paper' link='https://jeffhuang.com/papers/PortalInk_UIST24.pdf' />
                                            <Pub_link name='video' link='https://www.youtube.com/watch?v=yjAM70D7EiE' />
                                        </div>
                                    }
                                    />


                <Publication_temp imgSrc={img_chandelier} gifSrc={gif_chandelier}
                                    title="Chandelier: Interaction Design With Surrounding Mid-Air Tangible Interface"
                                    author={<p><b>Vivian Hsinyueh Chan</b>, Chiao Fang, Yukai Hung, Jing-Yuan Huang, and Lung-Pan Cheng</p>}
                                    status={<p>Poster at UIST 2023</p>}
                                    links={
                                        <div>
                                            <Pub_link name='ACM' link='https://dl.acm.org/doi/10.1145/3586182.3616695' />
                                            <Pub_link name='paper' link={pdf_chandelier} />
                                            <Pub_link name='video' link='https://www.youtube.com/watch?v=glWRAA1kOkI' />
                                        </div>
                                    }
                                    />

                <Publication_temp imgSrc={img_structcode} gifSrc={gif_structcode}
                                    title="StructCode: Leveraging Fabrication Artifacts to Store Data in Laser-Cut Objects"
                                    author={<p>Mustafa Doga Dogan, <b>Vivian Hsinyueh Chan</b>, Richard Qi, Grace Tang, Thijs Roumen, Stefanie Mueller</p>}
                                    status={<p>In Proceedings at ACM SCF 2023</p>}
                                    links={
                                        <div>
                                            <Pub_link name='ACM' link='https://dl.acm.org/doi/10.1145/3623263.3623353' />
                                            <Pub_link name='paper' link='https://groups.csail.mit.edu/hcie/files/research-projects/structcode/2023-SCF-StructCode-paper.pdf' />
                                            <Pub_link name='video' link='https://www.youtube.com/watch?v=uZo7SyZV-gM' />
                                        </div>
                                    }
                                    />

                <Publication_temp imgSrc={img_polagons} gifSrc={gif_polagons}
                                    title="Polagons: Designing and Fabricating Polarized Light Mosaics with User-Defined Color-Changing Behaviors"
                                    author={<p>Ticha Sethapakdi, Laura Huang, <b>Vivian Hsinyueh Chan</b>, Lung-Pan Cheng, Fernando Fuzinatto Dall’Agnol, Mackenzie Leake, and Stefanie Mueller</p>}
                                    status={<p>In Proceedings at CHI 2023</p>}
                                    links={
                                        <div>
                                            <Pub_link name='ACM' link='https://doi.org/10.1145/3544548.3580639' />
                                            <Pub_link name='paper' link='http://groups.csail.mit.edu/hcie/files/research-projects/polagons/Polagons.pdf' />
                                            <Pub_link name='video' link='https://www.youtube.com/watch?v=6z4AanEHOuE&ab_channel=MITCSAILHCIEngineeringGroup' />
                                        </div>
                                    }
                                />

                <Publication_temp imgSrc={img_flaticulation} gifSrc={gif_flaticulation}
                                    title={<a href="https://dl.acm.org/doi/10.1145/3526113.3545695" target='_blank'>Flaticulation: Laser Cutting Joints with Articulated Angles</a>}
                                    author={<p>Chiao Fang*, <b>Vivian Hsinyueh Chan*</b>, and Lung-Pan Cheng</p>}
                                    status={<p>In Proceedings at UIST 2022</p>}
                                    links={
                                        <div>
                                            <Pub_link name='ACM' link='https://dl.acm.org/doi/10.1145/3526113.3545695' />
                                            <Pub_link name='paper' link={pdf_flaticulation} />
                                            <Pub_link name='video' link='https://youtu.be/Lv5tjHJSRvw' />
                                        </div>
                                    }
                                />

                
                <Publication_temp imgSrc={img_texel} gifSrc={gif_texel}
                    title={<a href='https://dl.acm.org/doi/abs/10.1145/3411763.3451653' target='_blank'>TexelBlocks: Dynamic Surfaces for Physical Interactions</a>}
                    author={<p><b>Vivian Hsinyueh Chan</b>, Yu-Chen Chan, Pin-Hsuan Peng, and Lung-Pan Cheng</p>}
                    status={<p>In Extended Abstract at CHI 2021</p>}
                    links={
                        <div>
                            <Pub_link name='ACM' link='https://dl.acm.org/doi/10.1145/3411763.3451653' />
                            <Pub_link name='paper' link={pdf_texel} />
                            <Pub_link name='video' link='https://www.youtube.com/watch?v=KYl8OgbFcIc&ab_channel=ACMSIGCHI' />
                            <Pub_link name='talk' link='https://www.youtube.com/watch?v=JFZryJoPvjE&ab_channel=ACMSIGCHI' />
                        </div>
                    }
                />
                {/*
                <Publication_temp imgSrc={img_chandelier} title="Chandelier: A Mid-Air Surrounding Shape Display"
                    author={<p><b>Vivian Hsinyueh Chan*</b>, Chiao Fang*, and Lung-Pan Cheng</p>}
                    status={<p>Submitted to CHI 2023, under Conference Review</p>}
                />
                */}

                {/*
                <Publication_temp imgSrc={img_structcode} title="StructCode: Embedding Information into the Structure of 3D Laser-Cut Objects"
                    author={<p>Mustafa Doga Dogan, <b>Vivian Hsinyueh Chan</b>, Richard Qi, Grace Tang, Ahmad Taka, Thelonious Abraham Cooper, Thijs Roumen, and Stefanie Mueller</p>}
                    status={<p>Submitted to CHI 2023, under Conference Review</p>}
                />
                */}
                <div className='more'>
                    <h3>I also enjoy design and making!<br/></h3>
                    <button className="more-button" id="design-button">
                        <a href={design} target="_blank">
                            Design Portfolio
                        </a>
                    </button>
                </div>

                <div className='more'>
                    <button className="more-button" id="cv-button">
                    <a href={pdf} target="_blank">
                        CV
                    </a>
                </button>

                </div>
                
            </div>
        )
    }
}

function Publication(props) {
    return (
        <div className="publication">
            <div className="publication-img">
                <img src={props.imgSrc}/>
            </div>
            <div className="publication-content">
                <h5>{props.title}</h5>
                {props.author}
                <p>{props.status}</p>
                <div>
                    {/*
                    <a href="" target="_blank">
                        <Tags color="orange" text="PDF"/>
                    </a>
                    */}
                </div>
            </div>
        </div>
    )
}

function Publication_temp(props) {
    return (
        <div className="publication">
            <div className="publication-img">
                <img className="static" src={props.imgSrc} />
                <img className="gif" src={props.gifSrc} />
            </div>
            <div className="publication-content">
                <h5>{props.title}</h5>
                <p>{props.author}</p>
                <p className='status'>{props.status}</p>
                {props.links}
                
            </div>
        </div>
    )
}

function Pub_link(props)
{
    return (
        <a className="Pub-link" href={props.link} target='_blank'>
            {props.name}
        </a>
    )
}
